import { DeleteOutlined, EditOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Card, Divider, Flex } from 'antd'
import React, { startTransition, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import CommonBottomDrawer from '../../../../Common/commonBottomDrawer/CommonBottomDrawer';
import TabsWithExtraBtn from '../../../../Common/tabs-with-extra-content/TabsWithExtraBtn';
import DiscoveredLicenseDrawer from './DiscoveredLicenseDrawer.js'

const DiscoveredLicense = () => {
    const history = useHistory();
    const licenseData = [
        {
            title:'MIT License 4.0 (12)',
        },
        {
            title:'Ruby License (10)',
        },
        {
            title:'MIT License 4.0 (12)',
        },
        {
            title:'Ruby License (10)',
        },
        {
            title:'Apache License 4.0 (10)',
        },
        {
            title:'Apache License 4.0 (10)',
        },
        {
            title:'Mozilla License 4.0',
        },
        {
            title:'Apache License 4.0 (10)',
        },
        {
            title:'Mozilla License 4.0',
        },
    ]
    const viewMore = ()=>{
        startTransition(() => {
          history.push("/sca-license");
        })
      }
    const handleDrawer = (title) =>{
        console.log('insidde handleDrawer-->',title);
        showDrawerModal()
    } 
    const [openDrawer, setOpenDrawer] = useState(false);
    const showDrawerModal = ()=>{
        console.log('onclick drawerModal');
        setOpenDrawer(true);
    }
    const tabsMenu = [
        {
          key: "all_details",
          label: "All Details",
          children: <DiscoveredLicenseDrawer />,
        },
        
      ];
      const operations = (
        <div className="extra_btn">
          <Button
            // onClick={handleOpenSmallModal}
            icon={<DeleteOutlined />}
            style={{ borderColor: "#1677ff", color: "#1677ff" }}
          >
            Delete
          </Button>
          <Button
            icon={<EditOutlined />}
            style={{ borderColor: "#1677ff", color: "#FFF", background: "#5A81FA" }}
          >
            Edit
          </Button>
        </div>
      );
      const [activeTabs, setActiveTabs] = useState("Vulnerability Details");
      const callback = (activekey) => {
        setActiveTabs(activekey);
        console.log("active-key ==", activekey);
      };
  return (
    <>
    <div className="top-issues">
        <div>DiscoveredLicense</div>
      </div>
    {
        licenseData.map((item,index)=>{
            return (
                <div key={index}>
                <Flex justify='space-between' style={{fontWeight:600,fontSize:'12.5px',padding:'10px' }}>
                    <div style={{color:'#63637D'}} >{item.title}</div>
                    <div onClick={()=> handleDrawer(item.title) } style={{color:'#5A81FA',textDecoration:'underline',cursor:'pointer'}} >View details</div>
                </Flex>
                <Divider type="horizontal" style={{ height: 'auto', margin: '0 4px' }} />
                </div>
            )
        })
    }
    <div className="view-more" onClick={() => viewMore()} ><EyeTwoTone style={{fontSize:'18px',marginRight:'5px'}} /> View More Details</div>

    {/* Drawer */}
    <CommonBottomDrawer
        title="MIT License 4.0"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Card>
          <TabsWithExtraBtn
            callback={callback}
            menu={tabsMenu}
            extraBtn={operations}
          />
        </Card>
    </CommonBottomDrawer>
    
    </>
  )
}

export default DiscoveredLicense